import React from "react"
import clsx from "clsx"

class HelperTemplateBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);
  };

 
  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <input type="hidden" name={'code'} value={this.props.id || ''} />
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <br />
              <div>{this.props.helper_template.code}</div>
            </div> 
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <br />
              <div>{this.props.helper_template.name}</div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <br />
              <div>{I18n.t(this.props.helper_template.status)}</div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">    
              <label>{I18n.t('content')}</label>
              <br />                
              <div dangerouslySetInnerHTML={{ __html: this.props.helper_template.body }} className="terms-and-conditions"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default HelperTemplateBuilderGeneral